import { useAppSelector } from "@/redux/store/hooks";

export function useIsPrivateSurveyMediaBucketEnabled(): boolean {
  const { features } = useAppSelector((state) => state.features);
  return Boolean(features?.enablePrivateBucketForSurvey?.enabled);
}
